import React from "react";
export default function DigiRapid(){
  return(
    <>
    <section className="digi-rapid-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-9">
            <h3 className="heading">Dox and Box  <b> digitizes millions </b> of records including documents, books,  <b>and microfilm.</b></h3>
            <p>We deliver structured digital archives in formats such as PDF and TIFF, enhanced with OCR and ICR technologies for fast search and retrieval.</p>
          </div>
        </div>
      </div>
    </section>
    </>
  )
}